import { Maybe, Operation } from '../../../__generated__/globalTypes'

import createImageWithUrlString from '../CreateImageWithURL.graphql'

export type CreateImageWithURLData = {
  uploadImage: {
    image: {
      id: string
      url: string
      smallThumb: string
      width: number
      height: number
    }
  }
}

export type CreateImageWithURLVariables = {
  url?: Maybe<string>
}

export type CreateImageWithURL = Operation<
  CreateImageWithURLData,
  CreateImageWithURLVariables
>

export const CreateImageWithURL = ({
  url,
}: CreateImageWithURLVariables = {}): CreateImageWithURL => ({
  query: createImageWithUrlString,
  variables: {
    url,
  },
})
